import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({ query: '[data-focus-on]' })
export class FocusOnComponent {
	private alreadyTransitionedElements: string[] = [];
	constructor(private element: HTMLElement) {
		const query = this.element.getAttribute('data-focus-on') ?? '';

		this.element.addEventListener('keydown', (e: KeyboardEvent) => {
			if (e.key === 'Enter') {
				this.focusOn(query);
			}
		});
	}

	async focusOn(query: string) {
		const el = document.querySelector(query) as HTMLElement;

		if (!el) return;

		const transition = window.getComputedStyle(el).transitionDuration;
		if (
			!transition ||
			transition == '0' ||
			transition == '0s' ||
			(this.alreadyTransitionedElements.includes(query) && !this.hasParentWithClass(el, 'hidden'))
		) {
			setTimeout(() => {
				el.focus();
			}, 200);
		} else {
			el.addEventListener(
				'transitionend',
				() => {
					el.focus();
					if (!this.alreadyTransitionedElements.includes(query)) {
						this.alreadyTransitionedElements.push(query);
					}
				},
				{
					once: true
				}
			);
		}
	}

	hasParentWithClass(element: HTMLElement, className: string) {
		let current = element.parentElement;
		while (current) {
			if (current.classList.contains(className)) {
				return true; // Found a parent with the class
			}
			current = current.parentElement; // Move up to the next parent
		}
		return false; // No parent has the class
	}
}
